import React, { useEffect, useState } from 'react';
import { colors } from '../../config/constants';
import { ClickAwayListener } from '@mui/material';

interface paginateHandlerProps {
  onClickPageNumber: (arg: number) => void;
  onNextClick: () => void;
  onPrevClick: () => void;
  onFirstClick: () => void;
  onLastClick: () => void;
  limitHandler: (arg: number) => void;
}

type PaginationProps = {
  page: number;
  limit: number;
  totalRowCount: number;
  paginateHandler: paginateHandlerProps;
};

const Pagination = (props: PaginationProps) => {
  const { page, limit, paginateHandler, totalRowCount } = props;
  const [paginationArray, setPaginationArray] = useState<number[]>([]);
  const [openLimitArray, setOpenLimitArray] = useState<boolean>(false);
  const limitArray: number[] = [20, 50, 100];
  const totalPage = Math.ceil(totalRowCount / limit);
  const [currentPage, setCurrentPage] = useState(0);

  const genaratePaginationArray = () => {
    const array = [];
    for (let i = 1; i <= totalPage; i++) {
      array.push(i);
    }
    setPaginationArray(array);
  };

  useEffect(() => {
    genaratePaginationArray();
  }, [limit, totalPage]);

  const showArrayNum = (pageNum: number) => {
    if (
      pageNum === 1 ||
      pageNum === totalPage ||
      (pageNum >= page - 1 && pageNum <= page + 1)
    ) {
      return (
        <div
          onClick={() => paginateHandler.onClickPageNumber(pageNum)}
          className={`${
            page === pageNum ? `text-white font-semibold bg-[#176B87]` : 'bg-white'
          } w-8 h-8 border border-[#176B87] ${
            colors.primaryText
          } m-1 flex items-center text-sm font-semibold justify-center cursor-pointer text-black`}
        >
          {pageNum}
        </div>
      );
    } else if (pageNum === page - 2 || pageNum === page + 2) {
      return <div className={`"font-bold ${colors.primaryText}`}>...</div>;
    } else {
      return null;
    }
  };

  return (
    <div data-testid="pagination-wrapper">
      <div className="flex items-center justify-start lg:justify-between text-sm ">
        <div className="flex items-center">
          <div className="text-[gray] hidden lg:block"> Rows per page :</div>
          <div
            onClick={() => setOpenLimitArray(!openLimitArray)}
            className="relative w-8 h-8 bg-blue-100 border-blue-500 border sm:mx-4 flex items-center justify-center cursor-pointer"
          >
            <div className="font-semibold">{limit}</div>
            {openLimitArray && (
              <ClickAwayListener onClickAway={() => setOpenLimitArray(false)}>
                <div className="shadow-lg absolute bottom-0 bg-white z-[1500]">
                  {limitArray.map((item, index) => {
                    return (
                      <div
                        onClick={() => paginateHandler.limitHandler(item)}
                        key={index}
                        className="w-10 h-10 border flex items-center justify-center font-semibold cursor-pointer"
                      >
                        {item}
                      </div>
                    );
                  })}
                </div>
              </ClickAwayListener>
            )}
          </div>

          <div className="text-[gray] ml-4 hidden lg:block"> Total Records :</div>

          <div
            className={`px-2 h-8 bg-blue-100 ${colors.primaryBorder} font-semibold  border m-1 flex items-center justify-center`}
          >
            {totalRowCount}
          </div>
        </div>
        <div className="flex items-center">
          <div
            onClick={() => paginateHandler.onFirstClick()}
            className={` ${
              page === 1 ? 'bg-[#bbbfbd]' : 'cursor-pointer'
            }  px-2 h-8 ${colors.primaryBorder} ${
              colors.primaryText
            } border m-1 flex items-center justify-center `}
          >
            <i className="fa-solid fa-angles-left"></i>
          </div>
          <div
            onClick={() => paginateHandler.onPrevClick()}
            className={`${page === 1 ? 'bg-[#bbbfbd]' : 'cursor-pointer'} px-2 h-8 ${
              colors.primaryBorder
            } ${colors.primaryText} border m-1 flex items-center justify-center`}
          >
            <i className="fa-solid fa-angle-left"></i>
          </div>
          {paginationArray.map((item: number, index: number) => {
            return <div key={index}>{showArrayNum(item)}</div>;
          })}
          <div
            onClick={() => paginateHandler.onNextClick()}
            className={` ${
              page === paginationArray[paginationArray.length - 1]
                ? 'bg-[#bbbfbd]'
                : 'cursor-pointer'
            } px-2 h-8 ${colors.primaryBorder} ${
              colors.primaryText
            }  border m-1 flex items-center justify-center `}
          >
            <i className="fa-solid fa-angle-right"></i>
          </div>
          <div
            onClick={() => paginateHandler.onLastClick()}
            className={` ${
              page === paginationArray[paginationArray.length - 1]
                ? 'bg-[#bbbfbd]'
                : 'cursor-pointer'
            } px-2 h-8 ${colors.primaryBorder} ${
              colors.primaryText
            } border m-1 flex items-center justify-center`}
          >
            <i className="fa-solid fa-angles-right"></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
